import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { api } from '@/lib/api';
import { getStoredRef } from '@/lib/attribution';
import { getStoredCode } from '@/lib/accessCode';
import { CONSENT_DOCS, MANDATORY_KEYS } from '@/lib/consents';
import { toast } from 'sonner';

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.71-1.57 2.68-3.89 2.68-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.97 10.72a5.41 5.41 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}

/** ISSUE-0156: optional ``consents`` map + ``requireMandatory`` for Register OAuth. */
export function GoogleLoginButton({
  testid = 'google-login-button',
  consents,
  requireMandatory = false,
}) {
  const { t } = useTranslation();
  const onClick = async () => {
    if (requireMandatory && !MANDATORY_KEYS.every((k) => consents?.[k])) {
      toast.error(t('consent_gate.accept_required'));
      return;
    }
    try {
      const ref = getStoredRef();
      const code = getStoredCode();
      const params = {};
      if (ref) params.ref = ref;
      if (code) params.code = code;
      if (consents) {
        const keys = CONSENT_DOCS.map((d) => d.key).filter((k) => consents[k]);
        if (keys.length) params.consents = keys.join(',');
      }
      const { data } = await api.get('/auth/social/google/start', { params });
      window.location.href = data.authorization_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || t('common.error'));
    }
  };
  return (
    <Button type="button" variant="outline" className="w-full h-11 gap-2" onClick={onClick} data-testid={testid}>
      <GoogleIcon />
      {t('auth.continue_google')}
    </Button>
  );
}
